import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate, useOutletContext } from "react-router-dom";
import { FaSave, FaArrowLeft } from "react-icons/fa";
import "../../styles/circuitoDesignSystem.css";

export default function EditarAssociadoCircuito() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { circuito, slugAtivo } = useOutletContext();
  const circuitoId = circuito?._id;

  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [form, setForm] = useState({
    nomeVaqueiro: "",
    cpfVaqueiro: "",
    equipe: "",
    categoria: "",
    cavalo: ""
  });

  const isCustomDomain = window.location.hostname !== "ticketdovaqueiro.com" && window.location.hostname !== "www.ticketdovaqueiro.com" && window.location.hostname !== "localhost";
  const basePath = isCustomDomain ? "/painel" : `/painel-circuito/${slugAtivo}`;

  useEffect(() => {
    if (circuitoId && id) buscarInscricao();
  }, [circuitoId, id]);

  const buscarInscricao = async () => {
    try {
      const token = localStorage.getItem("token");
      const { data } = await axios.get(
        `https://api.ticketdovaqueiro.com/api/circuitos/${circuitoId}/inscricoes/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setForm({
        nomeVaqueiro: data.nomeVaqueiro || "",
        cpfVaqueiro: data.cpfVaqueiro || "",
        equipe: data.equipe || "",
        categoria: data.categoria || "",
        cavalo: data.cavalo || ""
      });
    } catch (error) {
      console.error("Erro ao buscar inscrição:", error);
      alert("Erro ao carregar dados do associado.");
    } finally {
      setLoading(false);
    }
  };

  const handleCpfChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value.length > 11) value = value.slice(0, 11);
    if (value.length > 9) value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    else if (value.length > 6) value = value.replace(/(\d{3})(\d{3})(\d{1,3})/, "$1.$2.$3");
    else if (value.length > 3) value = value.replace(/(\d{3})(\d{1,3})/, "$1.$2");
    setForm({ ...form, cpfVaqueiro: value });
  };

  const handleSalvar = async (e) => {
    e.preventDefault();
    setSalvando(true);
    try {
      const token = localStorage.getItem("token");
      await axios.put(
        `https://api.ticketdovaqueiro.com/api/circuitos/${circuitoId}/inscricoes/${id}`,
        form,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert("Associação atualizada com sucesso!");
      navigate(`${basePath}/associados`);
    } catch (error) {
      alert(error.response?.data?.erro || "Erro ao salvar alterações.");
    } finally {
      setSalvando(false);
    }
  };

  if (loading) return <div style={{ padding: "40px", color: "#fff", textAlign: "center" }}>Carregando dados...</div>;

  return (
    <div style={{ paddingBottom: "40px" }}>
      <div className="pc-page-header" style={{ display: "flex", alignItems: "center", gap: "16px" }}>
        <button onClick={() => navigate(`${basePath}/associados`)} style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "#fff", padding: "12px", borderRadius: "8px", cursor: "pointer" }}>
          <FaArrowLeft />
        </button>
        <div>
          <h1 className="pc-page-header__title">Editar Associação</h1>
          <p className="pc-page-header__subtitle">Atualize os dados deste vaqueiro no circuito.</p>
        </div>
      </div>

      <form onSubmit={handleSalvar} className="pc-card" style={{ maxWidth: "600px" }}>
        <div style={{ display: "grid", gap: "16px" }}>
          
          <div>
            <label style={{ display: "block", marginBottom: "6px", color: "rgba(255,255,255,0.7)", fontSize: "14px" }}>Nome do Vaqueiro *</label>
            <input type="text" required className="c-input" style={{ width: "100%" }} value={form.nomeVaqueiro} onChange={(e) => setForm({ ...form, nomeVaqueiro: e.target.value })} />
          </div>

          <div>
            <label style={{ display: "block", marginBottom: "6px", color: "rgba(255,255,255,0.7)", fontSize: "14px" }}>CPF *</label>
            <input type="text" required className="c-input" style={{ width: "100%" }} value={form.cpfVaqueiro} onChange={handleCpfChange} />
          </div>

          <div>
            <label style={{ display: "block", marginBottom: "6px", color: "rgba(255,255,255,0.7)", fontSize: "14px" }}>Equipe de Representação *</label>
            <input type="text" required className="c-input" style={{ width: "100%" }} value={form.equipe} onChange={(e) => setForm({ ...form, equipe: e.target.value })} />
          </div>

          <div>
            <label style={{ display: "block", marginBottom: "6px", color: "rgba(255,255,255,0.7)", fontSize: "14px" }}>Nome do Cavalo (Opcional)</label>
            <input type="text" className="c-input" style={{ width: "100%" }} value={form.cavalo} onChange={(e) => setForm({ ...form, cavalo: e.target.value })} />
          </div>

          <div>
            <label style={{ display: "block", marginBottom: "6px", color: "rgba(255,255,255,0.7)", fontSize: "14px" }}>Categoria (Só permitida se o valor for o mesmo) *</label>
            <select required className="c-input" style={{ width: "100%" }} value={form.categoria} onChange={(e) => setForm({ ...form, categoria: e.target.value })}>
              {circuito?.categorias?.map((c, i) => (
                <option key={i} value={c.nome || c}>{c.nome || c}</option>
              ))}
            </select>
          </div>

        </div>

        <button type="submit" disabled={salvando} className="c-btn c-btn--primary" style={{ width: "100%", marginTop: "24px", height: "50px", fontSize: "16px", display: "flex", justifyContent: "center", alignItems: "center", gap: "8px" }}>
          <FaSave /> {salvando ? "Salvando..." : "Salvar Alterações"}
        </button>
      </form>
    </div>
  );
}